module.exports = __webpack_public_path__ + "static/media/isophya_camptoxypha_022_APA.4d22b984.png";